import { z, ZodType } from 'zod';

export type Balance = {
	balance: number;
	isBalanceInsufficient?: boolean;
	isSessionExpired?: boolean;
};

export const balanceSchema: ZodType<Balance> = z.object({
	balance: z.number(),
	isBalanceInsufficient: z.boolean().optional(),
	isSessionExpired: z.boolean().optional(),
});
